enum ContentMode {
	INFO = "INFO",
	LOGS = "LOGS",
	SUPPORT = "SUPPORT",
	WEBSERVICES = "WEBSERVICES",
	STATISTICS = "STATISTICS",
	DOCUMENTATION = "DOCUMENTATION",
	SESSIONS = "SESSIONS",
	CONNECTION = "CONNECTION"
}

export default ContentMode;